// extracted by mini-css-extract-plugin
export default {"ldio-18s9ayuergv":"BlockLoader_ldio-18s9ayuergv__Wz1cX","loadingio-spinner-blocks-4uebm1766j":"BlockLoader_loadingio-spinner-blocks-4uebm1766j__cQgmg"};